// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__35Lok","icon":"style_icon__1uys9","header-content":"style_header-content__329_M","title":"style_title__37NUq"};